"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("@/components/FromList/index.vue"));
var _systemPcConfig = require("@/api/systemPcConfig");
var _permission = require("@/utils/permission");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------\
// 权限判断函数
var _default = exports.default = {
  components: {
    FromList: _index.default
  },
  data: function data() {
    return {
      loadingBtn: false,
      loading: false,
      pcConfigForm: {
        bannerList: [],
        pcGoodStoreCoverImage: '',
        pcLogo: '',
        recommendProductList: [],
        recommendProductStr: ''
      },
      rules: {
        pcLogo: [{
          required: true,
          message: '请上传商户PCLogo',
          trigger: 'change'
        }],
        pcGoodStoreCoverImage: [{
          required: true,
          message: '请上传品牌好店封面图片',
          trigger: 'change'
        }]
      },
      // 店铺banner
      bannerListConfig: {
        tips: '最多可添加10张图片，建议1200px宽；鼠标拖拽左侧圆点可调整图片 顺序',
        title: '链接名称',
        isShowAddBtn: true,
        //添加按钮
        isShowEdit: true,
        //删除按钮
        isShowStatus: true,
        //开启状态
        isShowLinkUrl: true,
        //链接地址
        isShowImageUrl: true,
        //图片地址
        isShowName: false,
        maxList: 10,
        //最多可添加
        list: [{
          linkUrl: '',
          id: 0,
          sort: 0,
          imageUrl: '',
          status: false
        }]
      },
      goodsList: [] //选择的商品列表
    };
  },
  mounted: function mounted() {
    if ((0, _permission.checkPermi)(['merchant:config:pc:shopping:get'])) this.getPcConfig();
  },
  methods: {
    //上传图片
    modalPicTap: function modalPicTap(type, num) {
      var _this = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        if (num === 'pcLogo') {
          _this.pcConfigForm.pcLogo = img[0].sattDir;
          if (_this.pcConfigForm.pcLogo) _this.$refs.pcConfigForm.clearValidate(['pcLogo']);
        } else {
          _this.pcConfigForm.pcGoodStoreCoverImage = img[0].sattDir;
          if (_this.pcConfigForm.pcGoodStoreCoverImage) _this.$refs.pcConfigForm.clearValidate(['pcGoodStoreCoverImage']);
        }
      }, type, 'mallConfiguration');
    },
    //底部授权数据
    getPcConfig: function getPcConfig() {
      var _this2 = this;
      (0, _systemPcConfig.getPcConfigApi)().then(function (res) {
        Object.assign(_this2.pcConfigForm, res);
        _this2.bannerListConfig.list = _this2.pcConfigForm.bannerList || [];
        _this2.goodsList = _this2.pcConfigForm.recommendProductList || [];
      });
    },
    //选择商品
    handleAddGoods: function handleAddGoods() {
      var _this = this;
      this.$modalGoodList(function (row) {
        _this.getCheckedGoods(row);
      }, 'many', _this.goodsList, 20);
    },
    // 选中商品
    getCheckedGoods: function getCheckedGoods(row) {
      var _this = this;
      _this.goodsList = row;
    },
    handleDelete: function handleDelete(index) {
      this.goodsList.splice(index, 1);
    },
    // 获取保存数据的数据
    getSaveData: function getSaveData() {
      this.bannerListConfig.list.map(function (item, index) {
        item.sort = index + 1;
      });
      this.pcConfigForm.bannerList = this.bannerListConfig.list;
      if (this.goodsList.length) {
        var recommendProduct = [];
        this.goodsList.map(function (item) {
          recommendProduct.push(item.id);
        });
        this.pcConfigForm.recommendProductStr = recommendProduct.toString();
      } else {
        this.pcConfigForm.recommendProductStr = '';
      }
    },
    //保存
    handlePcConfigSave: function handlePcConfigSave(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this3.loadingBtn = true;
          _this3.getSaveData();
          (0, _systemPcConfig.savePcConfigApi)(_this3.pcConfigForm).then(function (res) {
            _this3.$message.success('保存成功');
            _this3.loadingBtn = false;
            _this3.getPcConfig();
          }).catch(function () {
            _this3.loadingBtn = false;
          });
        } else {
          return false;
        }
      });
    }
  }
};